import React from 'react'
import { FlexRow, Text, Icon, RouterLinkButton } from 'elements'

const styles = {
  primary: { fontSize: 'xlarge', fontWeight: 'bold', lineHeight: 'xlarge' },
  secondary: {
    color: 'background.0',
    fontSize: 'large',
    fontWeight: 'normal',
    lineHeight: 'large',
  },
}

export default function Breadcrumb({ crumbs, kind = 'primary' }) {
  return (
    <FlexRow alignItems="center">
      {crumbs?.map((crumb, idx) => {
        const isLast = idx === crumbs.length - 1

        return (
          <React.Fragment key={[crumb.label, idx]}>
            {crumb.href ? (
              <RouterLinkButton
                kind="transparent"
                area="xxsmall"
                to={crumb.href}
                onClick={crumb.onClick}
              >
                <Text {...styles[kind]} mr="xsmall" onClick={crumb.onClick}>
                  {crumb.label}
                </Text>
              </RouterLinkButton>
            ) : (
              <Text {...styles[kind]} mr="xsmall">
                {crumb.label}
              </Text>
            )}
            {!isLast ? (
              <Icon color="neutral.0" name="angle-right" mr="xsmall" size="medium" />
            ) : null}
          </React.Fragment>
        )
      })}
    </FlexRow>
  )
}
